import { render, staticRenderFns } from "./warren.vue?vue&type=template&id=bc5845a2&scoped=true&"
import script from "./warren.vue?vue&type=script&lang=js&"
export * from "./warren.vue?vue&type=script&lang=js&"
import style0 from "./warren.vue?vue&type=style&index=0&id=bc5845a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5845a2",
  null
  
)

export default component.exports